module.exports = __webpack_public_path__ + "images/emoji/birthday.fa336188841acf6ef964.png";